import styled from '@emotion/styled';

import LinkIconSVG from '@/assets/icons/icon_link.svg';
import { LiveButtonProps } from '@/components/layouts/Race/Singlerace/LiveButton/index';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const LinkIcon = styled.i(
  (props: { device: LiveButtonProps['device'] }) =>
    mq({
      display: 'inline-block',
      width: props.device === 'pc' ? '14px' : '12px',
      height: props.device === 'pc' ? '14px' : '12px',
      backgroundImage: `url(${LinkIconSVG})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      marginLeft:
        props.device === 'pc'
          ? defaultTheme.spacing.s
          : defaultTheme.spacing.xs,
    }),
);
